const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const longDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// defining patterns
var replaceChars = {
  // Day
  d: function (this: Date) { return (this.getDate() < 10 ? '0' : '') + this.getDate(); },
  D: function (this: Date) { return shortDays[this.getDay()]; },
  j: function (this: Date) { return this.getDate(); },
  l: function (this: Date) { return longDays[this.getDay()]; },
  N: function (this: Date) { return (this.getDay() == 0 ? 7 : this.getDay()); },
  S: function (this: Date) { return (this.getDate() % 10 == 1 && this.getDate() != 11 ? 'st' : (this.getDate() % 10 == 2 && this.getDate() != 12 ? 'nd' : (this.getDate() % 10 == 3 && this.getDate() != 13 ? 'rd' : 'th'))); },
  w: function (this: Date) { return this.getDay(); },
  z: function (this: Date) { var d = new Date(this.getFullYear(), 0, 1); return Math.ceil((this.getTime() - d.getTime()) / 86400000); }, // Fixed now
  // Week
  W: function (this: Date) {
    var target = new Date(this.valueOf());
    var dayNr = (this.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 3);
    var firstThursday = target.valueOf();
    target.setMonth(0, 1);
    if (target.getDay() !== 4) {
      target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
    }
    var retVal = 1 + Math.ceil((firstThursday - target.getTime()) / 604800000);

    return (retVal < 10 ? '0' + retVal : retVal);
  },
  // Month
  F: function (this: Date) { return longMonths[this.getMonth()]; },
  m: function (this: Date) { return (this.getMonth() < 9 ? '0' : '') + (this.getMonth() + 1); },
  M: function (this: Date) { return shortMonths[this.getMonth()]; },
  n: function (this: Date) { return this.getMonth() + 1; },
  t: function (this: Date) {
    var year = this.getFullYear(), nextMonth = this.getMonth() + 1;
    if (nextMonth === 12) {
      year = year++;
      nextMonth = 0;
    }
    return new Date(year, nextMonth, 0).getDate();
  },
  // Year
  L: function (this: Date) { var year = this.getFullYear(); return (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)); },   // Fixed now
  o: function (this: Date) { var d = new Date(this.valueOf()); d.setDate(d.getDate() - ((this.getDay() + 6) % 7) + 3); return d.getFullYear(); }, //Fixed now
  Y: function (this: Date) { return this.getFullYear(); },
  y: function (this: Date) { return ('' + this.getFullYear()).substr(2); },
  // Time
  a: function (this: Date) { return this.getHours() < 12 ? 'am' : 'pm'; },
  A: function (this: Date) { return this.getHours() < 12 ? 'AM' : 'PM'; },
  B: function (this: Date) { return Math.floor((((this.getUTCHours() + 1) % 24) + this.getUTCMinutes() / 60 + this.getUTCSeconds() / 3600) * 1000 / 24); }, // Fixed now
  g: function (this: Date) { return this.getHours() % 12 || 12; },
  G: function (this: Date) { return this.getHours(); },
  h: function (this: Date) { return ((this.getHours() % 12 || 12) < 10 ? '0' : '') + (this.getHours() % 12 || 12); },
  H: function (this: Date) { return (this.getHours() < 10 ? '0' : '') + this.getHours(); },
  i: function (this: Date) { return (this.getMinutes() < 10 ? '0' : '') + this.getMinutes(); },
  s: function (this: Date) { return (this.getSeconds() < 10 ? '0' : '') + this.getSeconds(); },
  u: function (this: Date) {
    var m = this.getMilliseconds(); return (m < 10 ? '00' : (m < 100 ?
      '0' : '')) + m;
  },
  // Timezone
  e: function (this: Date) { return /\((.*)\)/.exec(new Date().toString())![1]; },
  I: function (this: Date) {
    var DST: number | null = null;
    for (var i = 0; i < 12; ++i) {
      var d = new Date(this.getFullYear(), i, 1);
      var offset = d.getTimezoneOffset();

      if (DST === null) DST = offset;
      else if (offset < DST) { DST = offset; break; } else if (offset > DST) break;
    }
    return DST && (this.getTimezoneOffset() == DST) ? 1 : 0;
  },
  O: function (this: Date) { return (-this.getTimezoneOffset() < 0 ? '-' : '+') + (Math.abs(this.getTimezoneOffset() / 60) < 10 ? '0' : '') + Math.floor(Math.abs(this.getTimezoneOffset() / 60)) + (Math.abs(this.getTimezoneOffset() % 60) == 0 ? '00' : ((Math.abs(this.getTimezoneOffset() % 60) < 10 ? '0' : '')) + (Math.abs(this.getTimezoneOffset() % 60))); },
  P: function (this: Date) { return (-this.getTimezoneOffset() < 0 ? '-' : '+') + (Math.abs(this.getTimezoneOffset() / 60) < 10 ? '0' : '') + Math.floor(Math.abs(this.getTimezoneOffset() / 60)) + ':' + (Math.abs(this.getTimezoneOffset() % 60) == 0 ? '00' : ((Math.abs(this.getTimezoneOffset() % 60) < 10 ? '0' : '')) + (Math.abs(this.getTimezoneOffset() % 60))); }, // Fixed now
  T: function (this: Date) { return this.toTimeString().replace(/^.+ \(?([^\)]+)\)?$/, '$1'); },
  Z: function (this: Date) { return -this.getTimezoneOffset() * 60; },
  // Full Date/Time
  c: function (this: Date) { return format(this, "Y-m-d\\TH:i:sP"); }, // Fixed now
  r: function (this: Date) { return this.toString(); },
  U: function (this: Date) { return this.getTime() / 1000; }
};

export default function format (date: Date, format: string) {
  return format.replace(/(\\?)(.)/g, function (_, esc, chr) {
    return (esc === '' && replaceChars[chr]) ? replaceChars[chr].call(date) : chr;
  });
};

